import styled from "styled-components";

export const Container = styled.div`
  widht: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const Organograma = styled.img`
  width: 60%;
  height: auto;
  margin: 0 auto;
  border-radius: 10px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Observacao = styled.div`
  widht: 100%;
  height: auto;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background-color: #f8f9fa;
  padding: 20px;
  text-align: center;
`;
